export class GoogleUaEvent {

  /**
   * It creates payload for Universal Analytics event tag
   * @param {string} eventName Name of event
   */
  constructor(eventName) {
    this.eventName = eventName;
    this.category = '';
    this.action = '';
    this.label = '';
    this.value = {};
  }

  /**
   * Standard fields for Universal Analytics event tag 
   * @param {string} category - Event Category
   * @param {string} action - Event Action
   * @param {string} label - Event Label
   * @param {string|number|boolean} value - Event Value
   */
  setPayload(category, action, label, value) {
    this.category = category;
    this.action = action;
    this.label = label;
    this.value = value;
  }
}